import { json, MetaFunction } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';
import { Container } from '~/components/Container';
import { Layout } from '~/components/Layout';
import { PageHeading } from '~/components/PageHeading';
import { PageSubHeading } from '~/components/PageSubHeading';
import { TagLink } from '~/components/TagLink';
import { db } from '~/lib/db.server';
import { getCacheControlHeader } from '~/lib/http.server';
import { appendMetaTitleSuffix } from '~/lib/utils/meta';

export const loader = async () => {
  const categories = await db.category.findMany({
    include: {
      tags: {
        orderBy: {
          order: 'asc',
        },
      },
    },
    orderBy: {
      order: 'asc',
    },
  });

  return json(
    {
      categories,
    },
    {
      headers: {
        ...getCacheControlHeader()
      }
    }
  );
};

export const meta: MetaFunction = () => {
  return [
    { title: appendMetaTitleSuffix(`タグ`) },
    { name: 'description', content: 'StompBase（ストンプベース）に掲載されているエフェクターのタグの一覧です。タグでエフェクターを検索できます。' },
  ];
};

const TagsRoute = () => {
  const { categories} = useLoaderData<typeof loader>();

  return (
    <Layout>
      <Container>
        <PageHeading>タグ</PageHeading>

        <div>
          {categories.map((category) => (
            <div key={category.id} className="mb-10">
              <div className='mb-2'>
                <PageSubHeading color='gray'>
                  {category.name}
                </PageSubHeading>
              </div>

              <div className={'flex flex-wrap gap-4'}>
                {category.tags
                  .filter((tag) => tag.categoryId === category.id)
                  .map((tag) => (
                    <div key={tag.id} className="flex-shrink-0">
                      <TagLink id={tag.id} tag={tag.tag} pedalCount={tag.pedalCount} />
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>

      </Container>
    </Layout>
  );
};

export default TagsRoute;
